const SubmittedData = ({
  identificationDocUrl,
}: {
  identificationDocUrl: string;
}) => {
  return (
    <div>
      <h2 className="text-[#562B00] text-[20px] font-semibold pt-[20px] mb-[30px]">
        Submitted Details
      </h2>

      <div className="border-[1px] border-[#eeeeee] rounded-[10px] px-[10px] py-[20px]">
        <span className="w-6/12">
          <img
            src={identificationDocUrl ? identificationDocUrl : ""}
            alt=""
            className="w-full h-[200px] rounded-[10px]"
          />
          <h4 className="text-black mt-[15px] text-[18px] font-medium rounded-[10px]">
            National ID Card
          </h4>
          <span className="text-[#a8a8a8]">Tap to view</span>
        </span>
        {/* <span className="w-6/12">
          <img
            src={identificationDocUrl ? identificationDocUrl : ""}
            alt=""
            className="w-full h-[200px] rounded-[10px]"
          />
          <h4 className="text-black mt-[15px] text-[18px] font-medium ">
            Utility Bill
          </h4>
          <span className="text-[#a8a8a8]">Tap to view</span>
        </span> */}
      </div>
    </div>
  );
};

export default SubmittedData;
